export default __webpack_public_path__ + "static/media/CouplesImg.f30df03a.jpg";